import * as _ from 'lodash';

export function getBillingItemCoveragePrice(billingItemData: any, isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItemData.coverages && billingItemData.coverages.length > 0) {
    let index = billingItemData.coverages.findIndex((val: any) => val.type === 'override');
    if (index > -1 && billingItemData.coverages[index].amount) {
      amount = billingItemData.coverages[index].amount;
    } else {
      for (let coverage of billingItemData.coverages) {
        if (coverage.type && coverage.type === 'deduction') {
          if (coverage.amount)
            amount = +amount + +coverage.amount;
          else if (coverage.percentage)
            amount = +amount + ((+coverage.percentage / 100) * billingItemData.price);
        }
      }
    }
  }

  if (isTaxExclusive && billingItemData && billingItemData.tax) {
    let tax = billingItemData.tax / 100;
    let res = (amount < 0 ? 0 : +amount * tax);
    amount = +amount + res;
  }

  return amount;
}

export function getBillingItemCoverageByContractIdPrice(billingItemData: any, contractId: string, isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItemData.coverages && billingItemData.coverages.length > 0) {
    let index = billingItemData.coverages.findIndex((val: any) => (val.contract === contractId || val.refContract === contractId) && val.type === 'override');
    if (index > -1 && billingItemData.coverages[index].amount) {
      amount = billingItemData.coverages[index].amount;
    } else {
      for (let coverage of billingItemData.coverages) {
        if ((coverage.contract === contractId || coverage.refContract === contractId) && coverage.type && coverage.type === 'deduction') {
          if (coverage.amount)
            amount = +amount + +coverage.amount;
          else if (coverage.percentage)
            amount = +amount + ((+coverage.percentage / 100) * billingItemData.price);
        }
      }
    }
  }

  if (isTaxExclusive && billingItemData && billingItemData.tax) {
    let tax = billingItemData.tax / 100;
    let res = (amount < 0 ? 0 : +amount * tax);
    amount = +amount + res;
  }

  return amount;
}


export function getBillingItemCoverageByInsurerTypePrice(billingItemData: any, insurerType: string, insurerSubtype: string, isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItemData.coverages && billingItemData.coverages.length > 0) {
    let coverages: any[] = [];
    if (insurerType === 'insurance') {
      if (insurerSubtype) {
        coverages = billingItemData.coverages.filter((val: any) => val.insurerType === insurerType && val.insurerSubtype === insurerSubtype);
      }
    } else if (insurerType === 'corporate-partner') {
      coverages = billingItemData.coverages.filter((val: any) => val.insurerType === insurerType);
    }

    let index = coverages.findIndex((val: any) => val.type === 'override');
    if (index > -1 && coverages[index].amount) {
      amount = coverages[index].amount;
    } else {
      for (let coverage of coverages) {
        if (coverage.type && coverage.type === 'deduction') {
          if (coverage.amount)
            amount = +amount + +coverage.amount;
          else if (coverage.percentage)
            amount = +amount + ((+coverage.percentage / 100) * billingItemData.price);
        }
      }
    }
  }

  if (isTaxExclusive && billingItemData && billingItemData.tax) {
    let tax = billingItemData.tax / 100;
    let res = (amount < 0 ? 0 : +amount * tax);
    amount = +amount + res;
  }

  return amount;
}

export function getBillingItemCoverageByContractIdPaidAmount(billingItemData: any, contractId: string): number {
  let amount: number = 0;
  let index = billingItemData.coverages ? billingItemData.coverages.findIndex((val: any) => val.contract === contractId || val.refContract === contractId) : -1;
  if (index > -1) {
    const coverage: any = billingItemData.coverages[index];
    if (billingItemData && billingItemData._payments && billingItemData._payments.length > 0) {
      for (let payment of billingItemData._payments) {
        if ((payment.type === 'insurance-coverage' || payment.type === 'corporate-partner-coverage') &&
          payment.coverage === coverage.id) {
          amount = amount + payment.amount;
        }
      }
    }
  }

  return amount;
}

export function getBillingItemCoverageByInsurerTypePaidAmount(billingItemData: any, insurerType: string, insurerSubtype: string): number {
  let amount: number = 0;
  if (billingItemData.coverages) {
    let coverages: any[] = [];
    if (insurerType === 'insurance') {
      if (insurerSubtype) {
        coverages = billingItemData.coverages.filter((val: any) => val.insurerType === insurerType && val.insurerSubtype === insurerSubtype);
      }
    } else if (insurerType === 'corporate-partner') {
      coverages = billingItemData.coverages.filter((val: any) => val.insurerType === insurerType);
    }

    for (let coverage of coverages) {
      if (billingItemData && billingItemData._payments && billingItemData._payments.length > 0) {
        for (let payment of billingItemData._payments) {
          if ((payment.type === 'insurance-coverage' || payment.type === 'corporate-partner-coverage') &&
            payment.coverage === coverage.id) {
            amount = amount + payment.amount;
          }
        }
      }
    }
  }

  return amount;
}

export function getBillingItemCoverageDeductions(billingItemData: any, isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItemData.coverages && billingItemData.coverages.length > 0) {
    for (let coverage of billingItemData.coverages) {
      if (coverage.type && coverage.type === 'deduction') {
        if (coverage.amount)
          amount = +amount + +coverage.amount;
        else if (coverage.percentage)
          amount = +amount + ((+coverage.percentage / 100) * billingItemData.price);
      }
    }
  }

  if (isTaxExclusive && billingItemData && billingItemData.tax) {
    let tax = billingItemData.tax / 100;
    let res = (amount < 0 ? 0 : +amount * tax);
    amount = +amount + res;
  }

  return amount;
}






export function computeCoveragesTotalAmount(billingItems: any[], isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItems && billingItems.length > 0) {
    for (let billingItem of billingItems) {
      if (billingItem) {
        let newValue = getBillingItemCoveragePrice(billingItem);
        amount = amount + (newValue < 0 ? 0 : +newValue);
        if (isTaxExclusive && billingItem.tax) {
          let tax = billingItem.tax / 100;
          let code = billingItem.taxCode;
          let res = ((newValue < 0 ? 0 : +newValue) * tax);
          amount = amount + res;
        }
      }
    }
  }

  return amount;
}

export function computeCoveragesTotalPaidAmount(billingItems: any[], isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItems && billingItems.length > 0) {
    for (let billingItem of billingItems) {
      if (billingItem && billingItem._payments && billingItem._payments.length > 0) {
        for (let payment of billingItem._payments) {
          if ((payment.type === 'insurance-coverage' || payment.type === 'corporate-partner-coverage') &&
            payment.coverage && billingItem.coverages && billingItem.coverages
              .findIndex((coverage: any) => coverage.id === payment.coverage) > -1) {
            amount = amount + payment.amount;
          }
        }
      }
    }
  }

  return amount;
}

export function computeCoveragesTotalBalanceAmount(billingItems: any[], isTaxExclusive?: boolean): number {
  let totalAmount = computeCoveragesTotalAmount(billingItems, isTaxExclusive)
  let totalPaidAmount = computeCoveragesTotalPaidAmount(billingItems)
  return totalAmount - totalPaidAmount;
}

export function computeContractIdTotalAmount(billingItems: any[], contractId: string, isTaxExclusive?: boolean): number {
  let amount: number = 0;
  if (billingItems && billingItems.length > 0) {
    for (let billingItem of billingItems) {
      if (billingItem) {
        let newValue = getBillingItemCoverageByContractIdPrice(billingItem, contractId);
        amount = amount + (newValue < 0 ? 0 : +newValue);
        if (isTaxExclusive && billingItem.tax) {
          let tax = billingItem.tax / 100;
          let code = billingItem.taxCode;
          let res = ((newValue < 0 ? 0 : +newValue) * tax);
          amount = amount + res;
        }
      }
    }
  }

  return amount
}

export function computeContractIdTotalPaidAmount(billingItems: any[], contractId: string): number {
  let amount: number = 0;
  if (billingItems && billingItems.length > 0) {
    for (let billingItem of billingItems) {
      let index = billingItem.coverages ? billingItem.coverages.findIndex((val: any) => val.contract === contractId || val.refContract === contractId) : -1;
      if (index > -1) {
        const coverage: any = billingItem.coverages[index];
        if (billingItem && billingItem._payments && billingItem._payments.length > 0) {
          for (let payment of billingItem._payments) {
            if ((payment.type === 'insurance-coverage' || payment.type === 'corporate-partner-coverage') &&
              payment.coverage === coverage.id) {
              amount = amount + payment.amount;
            }
          }
        }
      }
    }
  }

  return amount;
}

export function computeContractIdTotalBalanceAmount(billingItems: any[], contractId: string, isTaxExclusive?: boolean): number {
  let totalAmount = computeContractIdTotalAmount(billingItems, contractId, isTaxExclusive)
  let totalPaidAmount = computeContractIdTotalPaidAmount(billingItems, contractId)
  return totalAmount - totalPaidAmount;
}